import { ReduxState } from '../../utils/typeHelpers'

export const getUserFocusAreas = (state: ReduxState) => state.userFocusAreas
